import React from 'react';
import ApprovalActions from '../approval/ApprovalActions';

// Repair-flavoured binding of the shared approval actions. The workflow itself lives in
// components/approval/ — repairs and requisitions use the same one so the two cannot drift.
//
// The chip constants are re-exported here because several repair screens (including the
// tenant portal) already import them from this path.
export { APPROVAL_LABELS, APPROVAL_COLORS, ApprovalChip } from '../approval/ApprovalChip';

const RepairApprovalActions = ({ repair, onChanged, size = 'small' }) => (
  <ApprovalActions
    item={repair}
    resourcePath="repairs"
    permissionModule="repairs"
    itemLabel={repair.title}
    noun="repair"
    onChanged={onChanged}
    size={size}
  />
);

export default RepairApprovalActions;
